export const RD_ANALYTICS_ID = 'rd_analytics'
export const SEND_GOOGLE_RESERVE_CONVERSION_DATA = 'SEND_GOOGLE_RESERVE_CONVERSION_DATA'
